import React, { Component } from "react";
import Slider from "react-slick";
import ditcl from "../../../assets/ditcl.png";
import sli from "../../../assets/sli.png";
import dragon from "../../../assets/dragon.png";
import dragonTex from "../../../assets/dragon-tex.png";
import { Link } from "react-router-dom";

export default class SimpleSlider extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 4000,
      autoplay: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplaySpeed: 500,
      cssEase: "linear",
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },

        {
          breakpoint: 999,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };
    return (
      <div className="container-fluid">
        <Slider {...settings}>
          <div className="sliderImg">
            <Link to="">
              <img src={ditcl} className="img-fluid" alt="" />
            </Link>
          </div>
          <div className="sliderImg">
            <Link to="">
              <img src={sli} className="img-fluid" alt="" />
            </Link>{" "}
          </div>
          <div className="sliderImg">
            <Link to="">
              <img src={dragon} className="img-fluid" alt="" />
            </Link>
          </div>
          <div className="sliderImg">
            <Link to="">
              <img src={dragonTex} className="img-fluid" alt="" />
            </Link>
          </div>
        </Slider>
      </div>
    );
  }
}
